import axios, { type AxiosError } from "axios"

export async function getContentJson<T>(url: string, errorMessage: string): Promise<T> {
        try {
                const { data } = await axios.get<T>(url)
                return data
        } catch (error) {
                const status = (error as AxiosError).response?.status
                throw new Error(status ? `${errorMessage}: ${status}` : errorMessage)
        }
}
